import LegalLinks from "./LegalLinks";

const BottomText = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <footer className="site-footer">
      <p className="site-footer__copyright mb-0">
        © Teach League <span>{year}</span>
      </p>
      <LegalLinks className="site-footer__legal" />
    </footer>
  );
};

export default BottomText;
